// extracted by mini-css-extract-plugin
export default {"container":"InvoiceSummary_container__U1suX","title":"InvoiceSummary_title__lrKA3"};